/**
 * BasisSwitcher (#2304) — the "je {Bezugsgröße}" segmented control that drives the DB1
 * denominator of the ranked table (page-owned, ``?basis=``). It sits on the feed's title row
 * since 2026-09-07, when the ranked bar chart that used to carry it was retired, and it offers
 * the drawer's five (``availableBases``: € gesamt and ha always, the rest when the data carries
 * the quantity) in the drawer's look, so the two switchers read as one control in two places.
 * All strings hardcoded German du-form.
 */
import { BASIS_META, type MarginBasis } from './basis';
import './BasisSwitcher.css';

interface BasisSwitcherProps {
  /** The active basis (page-owned, ``?basis=``). */
  basis: MarginBasis;
  /** The offered bases, in canonical order (from ``availableBases``). */
  options: MarginBasis[];
  onBasisChange: (basis: MarginBasis) => void;
}

export default function BasisSwitcher({ basis, options, onBasisChange }: BasisSwitcherProps) {
  return (
    <div className="deckungsbeitrag-basis-switch" role="group" aria-label="Bezugsgröße">
      {options.map((option) => (
        <button
          key={option}
          type="button"
          className="deckungsbeitrag-basis-switch__segment"
          aria-pressed={basis === option}
          onClick={() => onBasisChange(option)}
        >
          {BASIS_META[option].label}
        </button>
      ))}
    </div>
  );
}
